export * from './inputswitch';